import React, {
    useEffect,
    useState,
    useCallback
} from "react";


import {

    Calendar,

    Card,

    Typography,

    Tag,

    Space,

    Spin,

    Empty,

    Badge,

    Divider

} from "antd";


import {

    DollarOutlined,

    CalendarOutlined,

    UserOutlined

} from "@ant-design/icons";


import dayjs from "dayjs";


import api from "../../api/api";


import {
    useAcademicYear
} from "../../AcademicYearContext";



const {
    Title,
    Text
} = Typography;




const COLORS = {

    black:"#111111",

    orange:"#f97316",

    camel:"#c19a6b",

    light:"#f8f1e7",

    white:"#ffffff"

};






const CalendarViewAndTransaction = ()=>{


    const {
        selectedYear
    } = useAcademicYear();




    const [
        activities,
        setActivities
    ] = useState([]);




    const [
        loading,
        setLoading
    ] = useState(false);




    const [
        selectedDate,
        setSelectedDate
    ] = useState(
        dayjs()
    );



const fetchCalendar =
useCallback(

async(date)=>{


    if(!selectedYear)
        return;


    try{


        setLoading(true);



        // refresh latest transaction first
        await api.post(
            "/calendar/sync/",
            {
                date:
                date.format("YYYY-MM-DD")
            }
        );



        const response = await api.get(

            `/calendar/month/?year=${date.year()}&month=${date.month()+1}&academic_year=${selectedYear.id}`

        );



        setActivities(

            response.data.results
            ||
            response.data
            ||
            []

        );


    }
    catch(error){

        console.error(
            error
        );

    }
    finally{

        setLoading(false);

    }


},

[
    selectedYear
]);








    useEffect(()=>{


        fetchCalendar(
            selectedDate
        );


    },[
        selectedDate,
        fetchCalendar
    ]);










    const getActivity =
    (date)=>{


        return activities.find(

            item=>

            dayjs(item.date)
            .format(
                "YYYY-MM-DD"
            )

            ===

            date.format(
                "YYYY-MM-DD"
            )

        );


    };








    const selectedActivity =

    getActivity(
        selectedDate
    );










    const dateCellRender =
    (value)=>{


        const activity =

        getActivity(
            value
        );



        const today =

        value.isSame(
            dayjs(),
            "day"
        );



        return (

            <div

            style={{

                minHeight:45,

                padding:2,

                borderRadius:8,


                background:

                today

                ?

                COLORS.light

                :

                "transparent"


            }}

            >



            {
                today &&

                <CalendarOutlined

                    style={{

                        color:
                        COLORS.orange,

                        fontSize:12

                    }}

                />

            }




            {
                activity &&

                <Badge

                    dot

                    color={COLORS.orange}

                />

            }




            </div>

        );


    };









    return (

    <Card

        bordered={false}


        style={{

            height:"100%",

            borderRadius:20,


            boxShadow:

            "0 8px 25px rgba(0,0,0,.10)",


            background:

            COLORS.white


        }}


        bodyStyle={{

            padding:18

        }}


    >




        <Space

            direction="vertical"

            size={2}

            style={{

                width:"100%"

            }}

        >



            <Title

                level={4}

                style={{

                    margin:0,

                    color:
                    COLORS.black

                }}

            >

                School Calendar


            </Title>



            <Text

                type="secondary"

            >

                Academic Year:

                {" "}

                <b>

                {
                selectedYear?.name
                ||
                "Not Selected"
                }

                </b>


            </Text>


        </Space>





        <Divider

            style={{

                margin:"12px 0"

            }}

        />







        {
            loading &&

            <div

            style={{

                textAlign:"center",

                padding:10

            }}

            >

                <Spin/>

            </div>

        }







        <Calendar

            fullscreen={false}

            value={selectedDate}


            onPanelChange={

                (value)=>

                setSelectedDate(
                    value
                )

            }


            onSelect={

                (value)=>

                setSelectedDate(
                    value
                )

            }


            dateCellRender={

                dateCellRender

            }


        />









        <Card


            size="small"


            bordered={false}


            style={{

                marginTop:15,


                borderRadius:16,


                background:

                `linear-gradient(
                    135deg,
                    ${COLORS.black},
                    ${COLORS.camel}
                )`


            }}



            bodyStyle={{

                padding:15

            }}


        >




            <Text

                style={{

                    color:"white"

                }}

            >

                Selected Date


            </Text>





            <Title

                level={3}


                style={{

                    margin:"5px 0",

                    color:
                    COLORS.orange


                }}

            >

                {
                selectedDate.format(
                    "DD MMM YYYY"
                )
                }


            </Title>







            {

            selectedActivity ?



            <Space

                direction="vertical"

                size={5}

            >



                <Tag

                    color="orange"

                >

                    {
                    selectedActivity
                    .last_transaction_type
                    }


                </Tag>




                <Text

                    style={{

                        color:
                        COLORS.white

                    }}

                >


                    <UserOutlined/>

                    {" "}

                    {
                    selectedActivity
                    .last_transaction_name
                    }


                </Text>







                <Text

                    style={{

                        color:
                        COLORS.white

                    }}

                >


                    <DollarOutlined/>

                    {" "}

                    $

                    {
                    Number(

                    selectedActivity
                    .last_transaction_amount

                    )
                    .toFixed(2)

                    }



                </Text>



            </Space>




            :



            <Empty

                image={Empty.PRESENTED_IMAGE_SIMPLE}

                description="No transaction"

            />

            }



        </Card>




    </Card>


    );


};



export default CalendarViewAndTransaction;